import React from 'react';
import {StyledAutocompleteList, StyledAutocompleteListItem} from "@components/google/cityAutocomplete/cityAutocomplete.style";
import {IonSkeletonText} from "@ionic/react";

const AutocompleteSkeletonList: React.FC = () => {
    return (
        <>
            <StyledAutocompleteList>
                <StyledAutocompleteListItem>
                    <IonSkeletonText animated />
                </StyledAutocompleteListItem>
                <StyledAutocompleteListItem>
                    <IonSkeletonText animated />
                </StyledAutocompleteListItem>
                <StyledAutocompleteListItem>
                    <IonSkeletonText animated />
                </StyledAutocompleteListItem>
                <StyledAutocompleteListItem>
                    <IonSkeletonText animated />
                </StyledAutocompleteListItem>
                <StyledAutocompleteListItem>
                    <IonSkeletonText animated />
                </StyledAutocompleteListItem>
            </StyledAutocompleteList>
        </>
    );
};

export default AutocompleteSkeletonList;